import { UserInfo } from '../models/UserInfo';
const USER_INFO_LOCAL_STORAGE = 'userInfo';

// Only non-sensitive profile fields are kept; auth tokens live in HttpOnly cookies set by the backend.
function sanitizeUserInfo(userInfo: UserInfo): UserInfo {
	const { isMerchant, countryCode, email, fullName, id, userId, userStatus, language, role, allowedDepositOrder } =
		userInfo as any;
	return {
		isMerchant,
		countryCode,
		email,
		fullName,
		id,
		userId,
		userStatus,
		language,
		role,
		...(allowedDepositOrder !== undefined && { allowedDepositOrder }),
	};
}

export function setUserInfo(userInfo: UserInfo) {
	localStorage.setItem(USER_INFO_LOCAL_STORAGE, JSON.stringify(sanitizeUserInfo(userInfo)));
}
export function getUserInfo(): UserInfo | undefined {
	const userInfo = JSON.parse(localStorage.getItem(USER_INFO_LOCAL_STORAGE) || '{}');
	return userInfo;
}

export function deleteUserInfo() {
	localStorage.removeItem(USER_INFO_LOCAL_STORAGE);
}

// Sessions stored before the move to cookies still hold the access and refresh tokens; drop them.
(function removeLegacyTokens() {
	try {
		const stored = JSON.parse(localStorage.getItem(USER_INFO_LOCAL_STORAGE) || '{}');
		if ('token' in stored || 'refreshToken' in stored || 'expirationTime' in stored) {
			setUserInfo(stored);
		}
	} catch {
		// unreadable entry: leave it to the normal sign-in flow
	}
})();
